import { useField } from "formik";
import cn from "../../../lib/cn";

export const FormRadioGroup = ({
    label,
    name,
    options,
    onChange,
    wrapperClass,
    optionContainerClass,
    labelClass,
    disabled,
}) => {
    const [field, meta, helpers] = useField(name);

    const handleChange = (value) => {
        helpers.setValue(value);
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <div className={cn("w-full flex justify-between", wrapperClass)}>
            <div>
                {label && (
                    <p
                        className={cn(
                            "text-sm font-medium text-gray-700 mb-1",
                            disabled && "cursor-not-allowed ",
                            labelClass
                        )}
                    >
                        {label}
                    </p>
                )}
            </div>

            <div className={cn("flex gap-4", optionContainerClass)}>
                {options.map(
                    ({ label: optionLabel, value, icon, subLabel }, index) => (
                        <label
                            key={index}
                            className="flex items-center gap-1 cursor-pointer"
                        >
                            <input
                                type="radio"
                                name={name}
                                value={value}
                                checked={field.value === value}
                                onChange={() => handleChange(value)}
                                className="accent-blue"
                                disabled={disabled}
                            />
                            <div>
                                <span className="flex items-center text-nowrap gap-1 text-sm text-primary">
                                    {optionLabel}
                                    {icon && (
                                        <img
                                            src={icon}
                                            alt={value}
                                            className="w-2 h-2"
                                        />
                                    )}
                                </span>
                                <span className="text-xs text-secondary">
                                    {subLabel}
                                </span>
                            </div>
                        </label>
                    )
                )}
            </div>
            {meta.touched && meta.error && (
                <p className="text-red-500 text-xs mt-1">{meta.error}</p>
            )}
        </div>
    );
};
